import dutchMessages from "./nl";
import belgiumMessages from "./be";
import germanMessages from "./de";
import danishMessages from "./da";
import swissMessages from "./at";
import frenchMessages from "./fr";
import italianMessages from "./it";
import SwedishMessages from './se';

const messages = {
    nl: dutchMessages,
    be: belgiumMessages,
    de: germanMessages,
    at: swissMessages,
    dk: danishMessages,
    fr: frenchMessages,
    it: italianMessages,
    se: SwedishMessages,
};

messages.da = messages.dk;

export default messages;
